import { usePagination } from '../../utils';
import { Pagination } from '../Pagination/Pagination';
import { SelectMenu } from '../SelectMenu/SelectMenu';
import s from '../../styles/staff.module.css';
import { ROLE_LABELS } from '../../constants';

export function AdminTable({
  users, isLoading, isAdmin, currentUserId, roster = [], onNotify, onResetPassword, onLinkStaff,
}) {
  const { page, pageCount, pageItems, setPage } = usePagination(users, 10);

  const canReset = (m) => isAdmin || m.idUser === currentUserId;
  const showActions = isAdmin || users.some((m) => m.idUser === currentUserId);
  // Which technician a login works as. Admin-only, because it decides whose
  // timecard that person can clock in and out of.
  const showLink = isAdmin && !!onLinkStaff;
  const colCount = (showActions ? 6 : 5) + (showLink ? 1 : 0);

  const staffName = (m) => m.name
    || `${m.given_name || ''} ${m.family_name || ''}`.trim()
    || m.externalId;
  // A roster entry another login already holds cannot be offered twice.
  const takenBy = new Map(users.filter(u => u.idStaff).map(u => [String(u.idStaff), u.idUser]));

  return (
    <div className={s.userTable}>
      <div className={s.sectionLabel}>Users ({users.length})</div>
      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Username</th>
              <th>Email</th>
              <th>Role</th>
              {showLink && <th>Linked in as</th>}
              {showActions && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr><td colSpan={colCount} className={s.loading}>Loading…</td></tr>
            )}
            {!isLoading && users.length === 0 && (
              <tr><td colSpan={colCount} className={s.empty}>No users yet</td></tr>
            )}
            {!isLoading && pageItems.map((m) => (
              <tr key={m.idUser}>
                <td>{m.firstName}</td>
                <td>{m.lastName}</td>
                <td>{m.username || '—'}</td>
                <td>{m.email}</td>
                <td>
                  <span className={`${s.roleBadge} ${m.role === 'admin' ? s.roleBadgeAdmin : ''}`}>
                    {ROLE_LABELS[m.role]}
                  </span>
                </td>
                {showLink && (
                  <td>
                    <SelectMenu
                      value={m.idStaff || ''}
                      placeholder="Not on the floor"
                      onChange={(v) => onLinkStaff(m, v || null)}
                      options={[{ value: '', label: 'Not on the floor' }].concat(
                        roster.map((r) => {
                          // A roster entry another login already holds cannot be
                          // taken twice: two accounts clocking in as one person
                          // would produce two timecards for one day.
                          const held = takenBy.get(String(r.idStaff));
                          const taken = held != null && held !== m.idUser;
                          return {
                            value: String(r.idStaff),
                            label: staffName(r),
                            note: taken ? 'already linked' : undefined,
                            disabled: taken,
                          };
                        }),
                      )}
                    />
                  </td>
                )}
                {showActions ? (
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      {isAdmin && (
                        <button className={s.actionBtn} onClick={onNotify(m)}>Notify</button>
                      )}
                      {canReset(m) && (
                        <button className={s.actionBtn} onClick={() => onResetPassword(m)}>Reset Password</button>
                      )}
                    </div>
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination page={page} pageCount={pageCount} onPage={setPage} />
    </div>
  );
}
